import { render, staticRenderFns } from "./asyncBtn.vue?vue&type=template&id=60451ad6"
import script from "./asyncBtn.vue?vue&type=script&lang=js"
export * from "./asyncBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports